import React, { FC } from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';

import './apple-watch-instructions.dialog.css';

export interface AppleWatchInstructionsDialogProps {
  open: boolean;
  onClose: () => void;
}

const AppleWatchInstructionsDialog: FC<AppleWatchInstructionsDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ className: 'apple-watch-instructions-paper' }}
    >
      <Typography className="apple-watch-instructions-title">Connect Apple Watch</Typography>

      <Typography className="apple-watch-instructions-intro">
        Apple Watch can&apos;t be connected from the web app. Use the CoeLab iOS app on your iPhone to pair and sync
        your health data.
      </Typography>

      <Typography className="apple-watch-instructions-section-title">How to connect</Typography>
      <ol className="apple-watch-instructions-steps">
        <li>Open the CoeLab app on your iPhone</li>
        <li>Go to your Profile</li>
        <li>Scroll down to the &quot;Connected Devices&quot; section</li>
        <li>Tap Apple Watch</li>
        <li>Allow CoeLab permission to connect and sync your health data</li>
      </ol>

      <Typography className="apple-watch-instructions-section-title">Troubleshooting sync</Typography>
      <Typography className="apple-watch-instructions-body">
        While connected, new workouts autosync to CoeLab automatically whenever the iOS app is running.
      </Typography>
      <Typography className="apple-watch-instructions-body">
        If workouts aren&apos;t showing up, go to the &quot;Connected Devices&quot; section, tap the ellipsis (...) next
        to Apple Watch, and tap &quot;Resync&quot;. This attempts to sync the last 2 weeks of previously un-synced
        workouts.
      </Typography>

      <Box className="apple-watch-instructions-actions">
        <Button variant="contained" color="primary" onClick={onClose}>
          Got it
        </Button>
      </Box>
    </Dialog>
  );
};

export default AppleWatchInstructionsDialog;
